/**
 * Minimal RFC-4180 tokenizer: quoted fields, "" escaped quotes, commas and
 * newlines inside quotes, CRLF/LF, leading BOM. Returns raw records untrimmed;
 * callers apply their own header/empty-row/trim handling.
 * ponytail: hand-rolled to avoid a dependency; upgrade to papaparse only if we
 * need delimiter sniffing, streaming, or malformed-input recovery.
 */
export function parseCsvRows(input: string): string[][] {
  const text = input.replace(/^﻿/, '');
  const records: string[][] = [];
  let field = '';
  let record: string[] = [];
  let inQuotes = false;

  const pushField = () => {
    record.push(field);
    field = '';
  };
  const pushRecord = () => {
    pushField();
    records.push(record);
    record = [];
  };

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (inQuotes) {
      if (char === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += char;
      }
      continue;
    }
    if (char === '"') {
      inQuotes = true;
    } else if (char === ',') {
      pushField();
    } else if (char === '\r') {
      if (text[i + 1] === '\n') i++;
      pushRecord();
    } else if (char === '\n') {
      pushRecord();
    } else {
      field += char;
    }
  }
  if (field !== '' || record.length > 0) pushRecord();

  return records;
}
